"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLineFrameSearchModel = instanceOfLineFrameSearchModel;
exports.LineFrameSearchModelFromJSON = LineFrameSearchModelFromJSON;
exports.LineFrameSearchModelFromJSONTyped = LineFrameSearchModelFromJSONTyped;
exports.LineFrameSearchModelToJSON = LineFrameSearchModelToJSON;
exports.LineFrameSearchModelToJSONTyped = LineFrameSearchModelToJSONTyped;
/**
 * Check if a given object implements the LineFrameSearchModel interface.
 */
function instanceOfLineFrameSearchModel(value) {
    return true;
}
function LineFrameSearchModelFromJSON(json) {
    return LineFrameSearchModelFromJSONTyped(json, false);
}
function LineFrameSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'frameName': json['frameName'] == null ? undefined : json['frameName'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}
function LineFrameSearchModelToJSON(json) {
    return LineFrameSearchModelToJSONTyped(json, false);
}
function LineFrameSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'frameName': value['frameName'],
        'status': value['status'],
    };
}
